import { SALESFORCE_LEADS_CONFIG, isSalesforceLeadsEnabled } from "./salesforce";
import { mapFormDataToSalesforce } from "../utils/salesforceMapper";

const buildAuthHeaders = () => {
  const { apiKey, keyHeader } = SALESFORCE_LEADS_CONFIG;
  if (!apiKey) return {};

  if (keyHeader.toLowerCase() === "authorization") {
    const value = apiKey.toLowerCase().startsWith("bearer ") ? apiKey : `Bearer ${apiKey}`;
    return { Authorization: value };
  }

  return { [keyHeader]: apiKey };
};

const readTxId = (response, body) => {
  return (
    response.headers.get("tx-id") ||
    response.headers.get("x-tx-id") ||
    body?.data?.txId ||
    body?.txId ||
    body?.["tx-id"] ||
    body?.transactionId ||
    null
  );
};

const createIdempotencyKey = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const sendToSalesforce = async (formData) => {
  try {
    if (!isSalesforceLeadsEnabled()) {
      console.log("Salesforce UAT no habilitado o faltan URL/key, omitiendo envío");
      return { skipped: true };
    }

    const payload = mapFormDataToSalesforce(formData);
    const url = SALESFORCE_LEADS_CONFIG.url;

    console.log("Enviando lead a Salesforce UAT:", payload);
    console.log("URL de Salesforce leads:", url);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Idempotency-Key": createIdempotencyKey(),
        ...buildAuthHeaders(),
      },
      body: JSON.stringify(payload),
    });

    const contentType = response.headers.get("content-type") || "";
    let body = null;
    if (contentType.includes("application/json")) {
      body = await response.json();
    } else {
      const text = await response.text();
      body = text ? { message: text } : null;
    }

    if (!response.ok && response.status !== 202) {
      console.error("Error de Salesforce leads:", response.status, body);
      throw new Error(`Error de Salesforce leads: ${response.status} - ${JSON.stringify(body)}`);
    }

    const txId = readTxId(response, body);
    console.log("Respuesta de Salesforce UAT:", { status: response.status, txId, body });
    return { status: response.status, txId, body };
  } catch (error) {
    console.error("Error al enviar a Salesforce UAT:", error);
    throw error;
  }
};
